import React, { createContext, useState, useContext } from 'react';
import API from '../utils/api';

const AdminContext = createContext();

export const AdminProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const api = async (method, url, data = null, isFormData = false) => {
    setLoading(true);
    setError(null);
    try {
      const config = {};
      if (isFormData) config.headers = { 'Content-Type': 'multipart/form-data' };
      let res;
      if (method === 'get' || method === 'delete') {
        res = await API[method](url, config);
      } else {
        res = await API[method](url, data, config);
      }
      return { success: true, data: res.data };
    } catch (err) {
      const msg = err.response?.data?.message || err.message;
      setError(msg);
      return { success: false, message: msg };
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminContext.Provider value={{ loading, error, setError, api }}>
      {children}
    </AdminContext.Provider>
  );
};

export const useAdmin = () => useContext(AdminContext);
export default AdminContext;
